import OrderAddressSearchComponent from "../order/OrderAddressSearchComponent.tsx";
import {imageMap} from "../../images/imageMap.ts";

export default function IdaHeroComponent() {
    return (
        <>
            <div id={'hero-container'} className={'hero-container hero-container--usp hero-container--ida teal'}>
                <div className={'hero-background-wrapper'}>
                    <div className={'hero-background'}/>
                </div>

                <div className={'hero-content'}>
                    <h1 className={'heading heading--montserrat'}>
                        Som medlem af
                        <img
                            src={imageMap.alternative_frontpages.ida_logo}
                            alt={'IDA'}
                        />
                        kan du få lynhurtigt internet med særlig rabat.<br className={'hide-on-small-devices'}/>{' '}
                        Brug koden <span className={'discount-code'}><strong>IDArabat</strong></span> og få <strong>15&nbsp;kr. ekstra&nbsp;rabat hver&nbsp;måned</strong>
                    </h1>
                </div>

                <div className={'address-wrap'}>
                    <h2>Se hvilket tilbud du kan få
                        <div className={'scroll-down-arrow'}/>
                    </h2>
                    <OrderAddressSearchComponent/>
                </div>
            </div>
        </>
    )
}
